export async function getContentType(
  attachmentId: string,
  contentTypeEndpoint?: string,
  signal?: AbortSignal,
): Promise<'image' | 'video' | 'audio' | 'pdf' | 'unknown'> {
  try {
    if (!contentTypeEndpoint) {
      return 'unknown';
    }

    const response = await fetch(`${contentTypeEndpoint}?id=${attachmentId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      signal,
    }).then((res) => res.json());

    if (!response.ok) {
      return 'unknown';
    }

    const contentType = response.contentType as string;

    if (contentType?.startsWith('image/')) {
      return 'image';
    }
    if (contentType?.startsWith('video/')) {
      return 'video';
    }
    if (contentType?.startsWith('audio/')) {
      return 'audio';
    }
    if (contentType?.startsWith('application/pdf')) {
      return 'pdf';
    }

    return 'unknown';
  } catch (error) {
    console.error('Error getting content type:', error);

    return 'unknown';
  }
}
